import React, { useEffect, useState } from 'react';

import SquareModal from '../_composedBlocks/SquareModal';
import ItemSection from '../../ItemSection';

import styles from './PackageDetailsModal.module.scss';

const {
  'package-details-modal-body': packageDetailsModalBodyClass,
  'package-name-column': packageNameColumnClass,
  'package-name-square': packageNameSquareClass,
  'package-services-column': packageServicesColumnClass,
  'services-header': servicesHeaderClass,
  'upgrade-header': upgradeHeaderClass,
  upgrades: upgradesClass
} = styles;

const PackageDetailsModal = ({
  closeModal,
  modalVisible,
  name,
  colors,
  image,
  description,
  services = [],
  addOns = []
}) => {
  const { color1 } = colors || {};
  const [activeItems, setActiveItems] = useState({});

  // reset state on modal close
  useEffect(() => {
    if (!modalVisible) {
      setActiveItems({});
    }
  }, [modalVisible]);

  const handleToggleActive = name => {
    setActiveItems(prev => ({ ...prev, [name]: !prev[name] }));
  };

  return (
    <SquareModal closeOnOverlayClick {...{ closeModal, modalVisible }}>
      <div className={packageDetailsModalBodyClass}>
        <div className={packageNameColumnClass} style={{ backgroundImage: `url('${image}')` }}>
          <div className={packageNameSquareClass} style={{ backgroundColor: color1 }}>
            <h4>Included in the</h4>
            <h1>{name}</h1>
          </div>
        </div>
        <div className={packageServicesColumnClass}>
          <div className={servicesHeaderClass}>
            <h2>In this package</h2>
            <p>{description}</p>
          </div>
          <div>
            {services.map(s => (
              <ItemSection
                name={s.name}
                description={s.description}
                key={`${s.name}_${s.description}`}
                {...{ activeItems, handleToggleActive }}
              />
            ))}
          </div>
          <div className={upgradesClass}>
            <p className={upgradeHeaderClass}>upgrades</p>
            {addOns?.map(s => (
              <ItemSection
                name={s.name}
                description={s.description}
                key={`${s.name}_${s.description}`}
                {...{ activeItems, handleToggleActive }}
              />
            ))}
          </div>
        </div>
      </div>
    </SquareModal>
  );
};

export default PackageDetailsModal;
